import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { provideTranslocoScope, translateObjectSignal, TranslocoDirective } from '@jsverse/transloco';
import { UpgradeButtonComponent } from '@rma/dashboard/billing/public/orc-upgrade-button';
import { SubscriptionInterval, SubscriptionTiers } from '@rma/dashboard/generic/domain/to-be-sorted';
import { ListComponent, ListItemComponent } from '@rma/dashboard/generic/ui/lists';
import { StaticImageUrlPipe } from '@rma/dashboard/generic/util/pipes/static-image-url';
import { AppendReturnUrlParamsPipe } from '@rma/dashboard/generic/util/router-utils';

const TRANSLATION_SCOPE = 'welcomeModal';

@Component({
  selector: 'rma-welcome-modal',
  imports: [
    AppendReturnUrlParamsPipe,
    MatDialogModule,
    ListComponent,
    ListItemComponent,
    StaticImageUrlPipe,
    TranslocoDirective,
    UpgradeButtonComponent,
  ],
  providers: [provideTranslocoScope(TRANSLATION_SCOPE)],
  templateUrl: './welcome-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WelcomeModalComponent {
  protected readonly attract = inject<string>(MAT_DIALOG_DATA);

  protected readonly scope = TRANSLATION_SCOPE;
  protected readonly translations = translateObjectSignal('benefits.items', {}, TRANSLATION_SCOPE);
  protected readonly tier = SubscriptionTiers.Attract;
  protected readonly interval: SubscriptionInterval = 'Month';

  protected readonly benefits = computed<string[]>(() => {
    const translations = this.translations();
    return Object.values(translations);
  });
}
